// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__tzBRw","spin":"styles_spin__Yvtkr"};